// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div_charts[data-v-4ab30484]{width:100%;height:100%}.div_charts[data-v-4ab30484]  .highcharts-container svg{width:100%!important;height:100%!important}", ""]);
// Exports
module.exports = exports;
